import React, { useState, useEffect } from "react";
import useMounted from "../../hooks/useMounted";
// import dummyUser from "../../assets/images/navigation-bar/dummy-user.png"
import {
  Dropdown,
  // Image,
  Button,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { logOut } from "../../modules/Auth/authSlice";
import {
  // UserStoryIcon,
  Logout03Icon,
  CheckmarkBadge04Icon,
  BackButtonIcon,
  ArrowUpRightIcon
} from "../../assets/icons";
import "./navbar.css";

export default function NavigationBar() {
  const location = useLocation();
  const { settings } = useSelector((state) => state.settings);

  const getUserInitial = (name) => {
    return name
      ? (name
          .split(" ")
          .map((n) => n.charAt(0))
          .join("")).toUpperCase()
      : "UN";
  };

  const hasMounted = useMounted();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(false);
  const [title, setTitle] = useState('dashboard');
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("toast-success");

  const user = localStorage.getItem("userData");
  let userData = null;
  if (user) {
    userData = JSON.parse(user);
  }
  
  const category = localStorage.getItem("category-data");
  let categoryData = null;
  if (category) {
    categoryData = JSON.parse(category);
  }

  const subCategory = localStorage.getItem("admin-sub-category-data");
  let subCategoryData = null;
  if (subCategory) {
    subCategoryData = JSON.parse(subCategory);
  }


  useEffect(() => {
    const handleTitleChange = () => {
      const data = JSON.parse(localStorage.getItem("page-data"));
      if (location.pathname.startsWith(`/organization/page/`)) {
        setTitle(data || "Page");
      }
    };
  
    window.addEventListener("page-title-updated", handleTitleChange);
  
    return () => {
      window.removeEventListener("page-title-updated", handleTitleChange);
    };
  }, [location.pathname]);

  useEffect(() => {
    let title = "dashboard"; // Default title

    if (location.pathname === "/") {
      title = "dashboard";
    } else if (
      location.pathname ===
      `/color-configuration`
    ) {
      title = "Colors Configuration"; 
    }
      else if (location.pathname === "/blogs") {
      title = "blogs";
    } else if (location.pathname === "/blog-add") {
      title = "add New blog";
    } else if (location.pathname.startsWith("/blog-edit/")) {
      title = "Edit blog";
    } else if (location.pathname === "/tags") {
      title = "tags";
    } else if (location.pathname === "/tag-add") {
      title = "add New tag";
    } else if (location.pathname.startsWith("/tag-edit/")) {
      title = "Edit tag";
    } else if (location.pathname === "/target-regions") {
      title = "Target Regions";
    } else if (location.pathname === "/galleries") {
      title = "gallery";
    } else if (location.pathname === "/gallery-add") {
      title = "add New gallery";
    } else if (location.pathname.startsWith("/gallery-edit/")) {
      title = "Edit gallery";
    // } else if (location.pathname === "/settings") {
    //   title = "settings";
    } else if (location.pathname === "/categories") {
      title = "categories";
    } else if (location.pathname === "/category-add") {
      title = "add New category";
    } else if (location.pathname.startsWith("/category-edit/")) {
      title = "Edit category";
    } else if (location.pathname === "/products") {
      title = "products";
    } else if (location.pathname === "/product-add") {
      title = "add New product";
    } else if (location.pathname.startsWith("/product-edit/")) {
      title = "Edit product";
    } else if (location.pathname === "/testimonials") {
      title = "Testimonials";
    } else if (location.pathname === "/testimonial-add") {
      title = "add New testimonial";
    } else if (location.pathname.startsWith("/testimonial-edit/")) {
      title = "Edit testimonial";
    } else if (location.pathname === "/clients") {
      title = "Clients";
    } else if (location.pathname === "/client-add") {
      title = "add New client";
    } else if (location.pathname.startsWith("/client-edit/")) {
      title = "Edit client";
    } else if (location.pathname === "/teams") {
      title = "Teams";
    } else if (location.pathname === "/team-add") {
      title = "add New team";
    } else if (location.pathname.startsWith("/team-edit/")) {
      title = "Edit team";
    } else if (location.pathname === "/inquiries") {
      title = "Inquiries";
    } else if (location.pathname === "/home-page") {
      title = "Home Page Page";
    } else if (location.pathname === "/about-us") {
      title = "About Us Page";
    } else if (location.pathname === "/privacy-policy") {
      title = "Privacy Policy Page";
    } else if (location.pathname === "/terms-conditions") {
      title = "Terms & Conditions Page";
    } else if (location.pathname === "/general") {
      title = "General Setting Page";
    }else if (location.pathname === `/company-details`) {
      title = "Company Details Page";
    }else if (location.pathname === `/domain`) {
      title = "Domain Page";
    }else if (location.pathname === `/social-links`) {
      title = "Social Links Page";
    }else if (location.pathname === `/logo`) {
      title = "Logo Page";
    }else if (location.pathname === `/google-analytics`) {
      title = "Google Analytics Content";
    } else if (location.pathname === "/seo-configuration") {
      title = "SEO Configuration Page";
    } else if (location.pathname.startsWith("/child-categories")) {
      title = "child Categories";
    } else if (location.pathname === "/child-category-add") {
      title = "add New child category";
    } else if (location.pathname.startsWith("/child-category-edit/")) {
      title = "Edit child category";
    } else if (location.pathname === "/pages") {
      title = "pages";
    } else if (location.pathname === "/page-add") {
      title = "add New page";
    } else if (location.pathname.startsWith("/page-edit/")) {
      title = "Edit page";
    }else if (location.pathname.startsWith("/sub-category-products/")){
      title = "Products"
    }else if (location.pathname.startsWith("/sub-category-product-add/")) {
      title = "add New product";
    }else if (location.pathname.startsWith("/sub-category-product-edit/")) {
      title = "Edit product";
    }else if (location.pathname.startsWith(`/page/`)) {
      const data = JSON.parse(localStorage.getItem("page-data"));
      title = data ? `${data}` : "Page";
    }else if (location.pathname.startsWith(`/gallery-categories`)) {
      title = "Gallery Category";
    }else if (location.pathname.startsWith(`/gallery-category-add`)) {
      title = "Add Category";
    }else if (location.pathname.startsWith(`/gallery-category-edit/`)) {
      title = "Edit Category";
    }else if (location.pathname.startsWith(`/gallery-images`)) {
      title = "Gallery Image";
    }else if (location.pathname.startsWith(`/gallery-image-add`)) {
      title = "Add Image";
    }else if (location.pathname.startsWith(`/gallery-image-edit/`)) {
      title = "Edit Image";
    }else if (location.pathname.startsWith(`/gallery-videos`)) {
      title = "Gallery Video";
    }else if (location.pathname.startsWith(`/gallery-video-add`)) {
      title = "Add Video";
    }else if (location.pathname.startsWith(`/gallery-video-edit/`)) {
      title = "Edit Video";
    }else if (location.pathname.startsWith(`/faqs`)) {
      title = "FAQs";
    }else if (location.pathname.startsWith(`/faq-add`)) {
      title = "Add FAQ";
    }else if (location.pathname.startsWith(`/faq-edit/`)) {
      title = "Edit FAQ";
    }else {
      title = "Not Found";
    }
    setTitle(title);
  }, [location.pathname]);

  const handleLogOut = async () => {
    try {
      await dispatch(logOut()).then((res) => {
        localStorage.removeItem("auth-token");
        localStorage.removeItem("userData");
        window.location.reload();
        if(res.success) {
          setToastMessage(res.message || "Logout successful");
          setToastVariant("toast-success");
          setShowToast(true);
          setTimeout(() => {
            if (hasMounted) {
              navigate("/login");
            }
          }, 2000);
        }
      });

      setToastMessage("Logout successful");
        setToastVariant("toast-success");
        navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      setToastMessage("Logout failed");
      setToastVariant("toast-danger");
      setShowToast(true);
      setTimeout(() => {
        if (hasMounted) {
          navigate("/login");
        }
      }, 2000);
    } finally {
      setTimeout(() => {
        if (hasMounted) {
          navigate("/login");
        }
      }, 2000);
    }
  };

  // const getUserInitial = (name) => {
  //   return name ? name.charAt(0).toUpperCase() : "U";
  // };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg={toastVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{toastMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="px-4 py-2 bg-white position-sticky custom-navigationbar">
        <div className="d-flex align-items-center justify-content-between">
          {  location.pathname.startsWith(`/child-categories`) ? (

                    <div
                     className="d-flex align-items-center justify-content-between cursor-pointer"
                    onClick={() => {
                     const categoryStack = JSON.parse(localStorage.getItem("category_id_stack") || "[]");

                    if (categoryStack.length >= 2) {
                      // Remove current category (last)
                      categoryStack.pop();

                      // Get the previous category
                      const previousCategory = categoryStack[categoryStack.length - 1];

                      // Update localStorage with the updated stack
                      localStorage.setItem("category_id_stack", JSON.stringify(categoryStack));

                      localStorage.setItem("admin-category-data", JSON.stringify({
                        id: previousCategory.id,
                        category_name: previousCategory.name
                      }));

                      // Navigate back
                      navigate(`/child-categories/${previousCategory.id}?page=1`);
                    } else {
                      // Clear and go to root categories
                      localStorage.removeItem("category_id_stack");
                      localStorage.removeItem("admin-category-data");
                      navigate(`/categories`);
                    }
                  }}
                >
                  <BackButtonIcon width={22} height={22} color="#444050" strokeWidth="2" />
                <h5 className="fw-semibold text-capitalize pg-title ms-2">{title} of {categoryData ? categoryData.category_name : ""}</h5>
                </div>
              
            ) : location.pathname.startsWith("/sub-category-products") ? 
            (
              <div className="d-flex align-items-center justify-content-between">
                <div 
                
                onClick={() => {
                     const categoryStack = JSON.parse(localStorage.getItem("category_id_stack") || "[]");

                    if (categoryStack.length >= 2) {
                      // Remove current category (last)
                      categoryStack.pop();

                      // Get the previous category
                      const previousCategory = categoryStack[categoryStack.length - 1];

                      // Update localStorage with the updated stack
                      localStorage.setItem("category_id_stack", JSON.stringify(categoryStack));

                      localStorage.setItem("admin-category-data", JSON.stringify({
                        id: previousCategory.id,
                        category_name: previousCategory.name
                      }));

                      // Navigate back
                      navigate(`/child-categories/${previousCategory.id}?page=1`);
                    } else {
                      // Clear and go to root categories
                      localStorage.removeItem("category_id_stack");
                      localStorage.removeItem("admin-category-data");
                      navigate(`/categories`);
                    }
                  }}
                
                className="cursor-pointer">{<BackButtonIcon width={22} height={22} color="#444050" strokeWidth="2" />}</div> 
                <h5 className="fw-semibold text-capitalize pg-title ms-2">{title} Of {subCategoryData ? subCategoryData.category_name : ""}</h5>
              </div>
            ) 
            : (location.pathname.startsWith("/sub-category-product-add/") ||
            location.pathname.startsWith("/sub-category-product-edit/")) ? 
            (
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="fw-semibold text-capitalize pg-title ms-2">{title} Of {subCategoryData ? subCategoryData.category_name : ""}</h5>
              </div>
            ):
            (location.pathname.startsWith(`/page/`))? 
            (
              <div className="d-flex align-items-center justify-content-between">
              <div onClick={() => {
                  navigate(`/pages`);
                }} className="cursor-pointer">{<BackButtonIcon width={22} height={22} color="#444050" strokeWidth="2" />}</div> 
                <h5 className="fw-semibold text-capitalize pg-title ms-2">{title}</h5>
              </div>
            )
            : (
              <h5 className="fw-semibold text-capitalize pg-title">{title}</h5>
            )
          }
         <div className="d-flex align-items-center gap-3">
         {settings?.domain_name && (
            <Button
              variant="primary"
              size="sm"
              className="me-3 d-flex align-items-center gap-1"
              onClick={() =>        
                window.open(`${settings.domain_name}`, "_blank")
              }
            >
             Visit Website {""}
             <ArrowUpRightIcon />
            </Button>
          )}

          <Dropdown className="profile-menu" align="end">
            <Dropdown.Toggle
              variant="link"
              id="dropdown-basic"
              className="position-relative p-0 profile-toggle"
            >
              
              {/* <Image
                src={dummyUser}
                className="h-100 w-100 d-inline-block"
                alt={`${userData?.data?.name} Image`}
                roundedCircle
              /> */}
              <div className="rounded-circle d-flex align-items-center justify-content-center user-profile-icon">
                {getUserInitial(userData?.data?.name)}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="mt-4 p-2 profile-submenu">
              <Dropdown.Item
                href="#/action-1"
                className="py-2 px-3 profile-menu-item"
              >
                <div className="d-flex align-items-center gap-2">
                  <div className="position-relative flex-shrink-1 profile-user">
                    {/* <Image
                      src={dummyUser}
                      className="h-100 w-100 d-inline-block"
                      alt={`${userData?.data?.name} Image`}
                      roundedCircle
                    /> */}
                    <div className="rounded-circle d-flex align-items-center justify-content-center user-profile-icon">
                      {getUserInitial(userData?.data?.name)}
                    </div>
                  </div>
                  <div className="overflow-hidden flex-grow-1">
                    <h6 className="fw-medium text-capitalize mb-0">
                      {userData?.data?.name}
                    </h6>
                    <div className="text-capitalize post-tag">{userData?.data?.company_name}</div>
                  </div>
                </div>
              </Dropdown.Item>
              <div className="profile-submenu-divider"></div>
              {/* <Dropdown.Item
                href="/profile"
                className="py-2 px-3 profile-menu-item"
              >
                <div className="d-flex align-items-center gap-2">
                  <UserStoryIcon
                    width={19}
                    height={19}
                    color="#444050"
                    strokeWidth="2"
                  />
                  <span className="ms-1 text-capitalize fw-normal">
                    My Profile
                  </span>
                </div>
              </Dropdown.Item> */}
              <div className="profile-submenu-divider"></div>
              <Dropdown.Item href="#" className="pt-2 pb-1 px-3  logout-btn">
                <Button
                  variant="link"
                  onClick={handleLogOut}
                  className="w-100 text-white d-flex align-items-center justify-content-center text-decoration-none gap-2"
                >
                  Logout
                  <span>
                    <Logout03Icon
                      width={15}
                      height={15}
                      color="#ffffff"
                      strokeWidth="2"
                    />
                  </span>
                </Button>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          </div>
        </div>
      </div>
    </>
  );
}
